import useAutomationsStore from '../../../../../../store/useAutomationsStore';
import ConfigField from '../ConfigField';
import { NODE_CONFIG_FIELDS } from '../../../constants';

export default function ForEachConfig({ data, onChange }) {
  const { nodes, selectedNode } = useAutomationsStore();
  const fields = NODE_CONFIG_FIELDS.logic_foreach;

  // Nodes that output collections (Get Members)
  const collectionNodes = nodes.filter(
    (n) =>
      n.id !== selectedNode?.id &&
      ['wallettwo_get_members'].includes(n.data?.nodeType)
  );

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1.5">
          Collection Source
        </label>
        <select
          value={data.collectionRef || ''}
          onChange={(e) => onChange('collectionRef', e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
        >
          <option value="">Select node that outputs a list...</option>
          {collectionNodes.map((n) => (
            <option key={n.id} value={n.id}>
              {n.data.label} ({n.data.nodeType.replace('wallettwo_', '')})
            </option>
          ))}
        </select>
      </div>

      {fields
        .filter((f) => f.key !== 'collectionRef')
        .map((field) => (
          <div key={field.key}>
            <label className="block text-xs font-medium text-gray-600 mb-1.5">
              {field.label}
            </label>
            <ConfigField
              field={field}
              value={data[field.key]}
              onChange={(v) => onChange(field.key, v)}
              allData={data}
              onChangeField={onChange}
            />
          </div>
        ))}

      <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg space-y-2">
        <p className="text-xs text-amber-700">
          The <strong>For Each</strong> node iterates over the selected collection. Each connected downstream node will execute once per item.
        </p>
        <p className="text-xs text-amber-700">
          Use <code className="bg-amber-100 px-1 rounded">{`{{${data.itemVariable || 'item'}.name}}`}</code> or <code className="bg-amber-100 px-1 rounded">{`{{${data.itemVariable || 'item'}.email}}`}</code> in downstream nodes to reference the current item.
        </p>
      </div>
    </div>
  );
}
